import { render, staticRenderFns } from "./loginBoard.vue?vue&type=template&id=39713ba2&scoped=true"
import script from "./loginBoard.vue?vue&type=script&lang=js"
export * from "./loginBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39713ba2",
  null
  
)

export default component.exports